exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@-webkit-keyframes ChannelForm_fadeIn__3ZXXH {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@keyframes ChannelForm_fadeIn__3ZXXH {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@-webkit-keyframes ChannelForm_fadeOut__hBINY {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes ChannelForm_fadeOut__hBINY {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n.ChannelForm_channelForm__3805U {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  width: 1000px;\n  min-width: 700px; }\n  .ChannelForm_channelForm__3805U .ChannelForm_paper__1y4j1 {\n    padding: 16px 24px 26px 24px;\n    box-sizing: border-box;\n    margin-bottom: 16px; }\n", ""]);

// exports
exports.locals = {
	"color": "#ff3b00",
	"colorSecondary": "#4caf50",
	"colorContrastText": "#ffffff",
	"colorLight": "#ff7349",
	"colorDark": "#ce3000",
	"colorSecondaryLight": "#81c784",
	"colorSecondaryDark": "#388e3b",
	"hostColor": "#eb8315",
	"hostColorSecondary": "#f44336",
	"hostColorContrastText": "#ffffff",
	"hostColorLight": "#ffa74a",
	"hostColorDark": "#cf6a00",
	"channelForm": "ChannelForm_channelForm__3805U",
	"paper": "ChannelForm_paper__1y4j1",
	"fadeIn": "ChannelForm_fadeIn__3ZXXH",
	"fadeOut": "ChannelForm_fadeOut__hBINY"
};